module.exports = __webpack_public_path__ + "static/media/heartipro-1.2cc70208.jpg";